var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99866 12C7.10323 12 7.99866 11.1046 7.99866 10C7.99866 8.89543 7.10323 8 5.99866 8C4.89409 8 3.99866 8.89543 3.99866 10C3.99866 11.1046 4.89409 12 5.99866 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99866 18.668C7.10323 18.668 7.99866 17.7725 7.99866 16.668C7.99866 15.5634 7.10323 14.668 5.99866 14.668C4.89409 14.668 3.99866 15.5634 3.99866 16.668C3.99866 17.7725 4.89409 18.668 5.99866 18.668Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99866 25.332C7.10323 25.332 7.99866 24.4366 7.99866 23.332C7.99866 22.2275 7.10323 21.332 5.99866 21.332C4.89409 21.332 3.99866 22.2275 3.99866 23.332C3.99866 24.4366 4.89409 25.332 5.99866 25.332Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7454 14.668H10.5854C9.89317 14.668 9.33203 15.3694 9.33203 16.2346V16.4346C9.33203 17.2999 9.89317 18.0013 10.5854 18.0013H26.7454C27.4376 18.0013 27.9987 17.2999 27.9987 16.4346V16.2346C27.9987 15.3694 27.4376 14.668 26.7454 14.668Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7454 21.332H10.5854C9.89317 21.332 9.33203 22.0335 9.33203 22.8987V23.0987C9.33203 23.9639 9.89317 24.6654 10.5854 24.6654H26.7454C27.4376 24.6654 27.9987 23.9639 27.9987 23.0987V22.8987C27.9987 22.0335 27.4376 21.332 26.7454 21.332Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7454 8H10.5854C9.89317 8 9.33203 8.70142 9.33203 9.56667V9.76667C9.33203 10.6319 9.89317 11.3333 10.5854 11.3333H26.7454C27.4376 11.3333 27.9987 10.6319 27.9987 9.76667V9.56667C27.9987 8.70142 27.4376 8 26.7454 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableModeIcon);
export default __webpack_public_path__ + "static/media/table_mode_icon.4cbd6ad6e5eed78b5202c547af14b60e.svg";
export { ForwardRef as ReactComponent };